export default __webpack_public_path__ + "static/media/xs-logo-vr.b441f237.svg";